import React from "react";
import { REASONS, STATS, IMAGES } from "@/lib/site";
import { Reveal, SectionHeading } from "@/components/landing/Reveal";
import { ReasonItem, StatCard } from "@/components/landing/GroupCards";

const ReasonList = () => (
  <div className="mt-8 space-y-6">
    {REASONS.map((reason, index) => (
      <Reveal key={reason.title} delay={index * 0.06}>
        <ReasonItem reason={reason} />
      </Reveal>
    ))}
  </div>
);

const StatsGrid = () => (
  <div data-testid="why-stats-grid" className="mt-5 grid grid-cols-2 gap-4 sm:gap-5">
    {STATS.map((stat, index) => (
      <Reveal key={stat.label} delay={0.12 + index * 0.06} className="h-full">
        <StatCard stat={stat} />
      </Reveal>
    ))}
  </div>
);

export const WhyUs = () => (
  <section
    id="why"
    data-testid="why-section"
    className="scroll-mt-32 lg:scroll-mt-40 bg-white lg:flex lg:min-h-screen lg:items-start pb-10 pt-6 sm:pb-14 sm:pt-8 lg:py-12"
  >
    <div className="mx-auto w-full max-w-6xl px-4 sm:px-6 lg:px-8">
      <div className="grid grid-cols-1 gap-10 lg:grid-cols-12 lg:gap-14">
        <div className="lg:col-span-6">
          <SectionHeading
            eyebrow="Why Moruya"
            title="How the group works"
          />
          <ReasonList />
        </div>

        <div className="lg:col-span-6">
          <Reveal delay={0.1}>
            <div className="overflow-hidden rounded-[20px] border border-slate-200 shadow-[var(--shadow-md)]">
              <img
                src={IMAGES.aerial}
                alt="Aerial view of Dubai"
                className="h-[200px] w-full object-cover sm:h-[240px]"
                loading="lazy"
              />
            </div>
          </Reveal>
          <StatsGrid />
        </div>
      </div>
    </div>
  </section>
);
